import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth.js";
import LoadingSpinner from "../../component/loading/LoadingSpinner.jsx";

const PrivateRoute = ({ children, requiredModule, allowedRoles }) => {
  const { user, loading, privilege } = useAuth();
  const modules = privilege?.modules;
  const role = privilege?.role;
  const location = useLocation();

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <LoadingSpinner size="large" color="#ffb502" />
      </div>
    );

  // User Must be logged in
  if (!user) return <Navigate to="/login" replace />;

  // If allowedRoles is defined, allow only those roles
  if (allowedRoles) {
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/404" replace />;
    }
    // If the role matches, skip the module check entirely
    return children;
  }

  // Otherwise, check module permission
  if (requiredModule && !modules?.[requiredModule]) {
    return <Navigate to="/404" replace />;
  }

  // Passed all checks
  return children;
};

export default PrivateRoute;
